import React from 'react';

import { CaldotcomAppointmenToolConfigurationPanel } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CaldotcomAppointmentToolConfigurationPanel';
import { CalendlyToolConfigurationPanel } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CalendlyToolConfigurationPanel';
import { CallTransferConfigurationPanel } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CallTransferConfigurationPanel';
import { CollectLeadInfoToolConfigurationPanel } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CollectLeadInfoToolConfigurationPanel';
import { CustomApiRequestToolConfigurationPanel } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CustomApiRequestToolConfigurationPanel/CustomApiRequestToolConfigurationPanel';
import { EmailHandoffToolConfigurationPanel } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/EmailHandoffToolConfigurationPanel';
import { FollowUpToolConfigurationPanel } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/FollowUpToolConfigurationPanel';
import { TakeoverRequestToolConfigurationPanel } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/TakeoverRequestToolConfigurationPanel';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';
import { ToolConfig, ToolGroupKind } from 'shared/interfaces/tools/Tool';

interface ToolConfigurationProps {
  updateToolConfigs: (toolConfigs: ToolConfig[]) => void;
  smartAssistant: SmartAssistant;
}

export function ToolConfiguration({ updateToolConfigs, smartAssistant }: ToolConfigurationProps) {
  const navigate = useNavigate();
  const { toolGroupKind: toolGroupKindString, smartAssistantId } = useParams();

  const handleClose = () => {
    navigate(`${ROUTE_LINKS.manageSmartAssistant}/${smartAssistantId}/tools`);
  };

  const handleUpdateToolConfigs = (toolConfigs: ToolConfig[]) => {
    updateToolConfigs(toolConfigs);
    handleClose();
  };

  const toolGroupKind = toolGroupKindString as ToolGroupKind;

  switch (toolGroupKind) {
    case ToolGroupKind.CALENDLY:
      return (
        <CalendlyToolConfigurationPanel
          onUpdate={handleUpdateToolConfigs}
          onBack={handleClose}
          smartAssistant={smartAssistant}
        />
      );
    case ToolGroupKind.EMAIL_HANDOFF:
      return (
        <EmailHandoffToolConfigurationPanel
          onUpdate={handleUpdateToolConfigs}
          onBack={handleClose}
          smartAssistant={smartAssistant}
        />
      );
    case ToolGroupKind.TAKEOVER_REQUEST:
      return <TakeoverRequestToolConfigurationPanel onUpdate={handleUpdateToolConfigs} onBack={handleClose} />;
    case ToolGroupKind.CALDOTCOM_APPOINTMENT_SCHEDULING:
      return <CaldotcomAppointmenToolConfigurationPanel onUpdate={handleUpdateToolConfigs} onBack={handleClose} />;
    case ToolGroupKind.CALL_TRANSFER:
      return <CallTransferConfigurationPanel onUpdate={handleUpdateToolConfigs} onBack={handleClose} />;
    case ToolGroupKind.FOLLOW_UP:
      return <FollowUpToolConfigurationPanel onUpdate={handleUpdateToolConfigs} onBack={handleClose} />;
    case ToolGroupKind.LEAD_COLLECTION:
      return (
        <CollectLeadInfoToolConfigurationPanel
          onUpdate={handleUpdateToolConfigs}
          onBack={handleClose}
          smartAssistant={smartAssistant}
        />
      );
    case ToolGroupKind.CUSTOM_API_REQUEST:
      return <CustomApiRequestToolConfigurationPanel onUpdate={handleUpdateToolConfigs} onBack={handleClose} />;
    default:
      return null;
  }
}
